<template>
  <ion-page>
    <master-layout pageTitle="افزودن انبار جدید">
      <ion-card>
        <ion-card-content>
          <AjaxForm route="Warehouse/Add" :callback="ajaxFormCallback">
            <input type="text" name="id" class="form-control" placeholder="id" />
            <br/>
            <br/>
            <input type="text" name="title" class="form-control" placeholder="title" />
            <br/>
            <br/>
            <input type="file" name="myFile">
            <br/>
            <button type="submit" class="btn btn-success">Do It</button>
          </AjaxForm>
          <br/>
          <AjaxForm route="warehouse/add">

<!--            <ali-select :onChange="simpleChange" :items="states" search="true" multiple="true" title="استان" itemTitle="title" desc="انتخاب کن !!!"  name="state_id" itemId="_id"></ali-select>-->

<!--            <div>-->
<!--            <br/>-->
<!--            </div>-->
<!--            <ali-ajax-select :onChange="ajaxChange"  :selected="selectedStates" route="app/getState" title="استان" itemTitle="title" name="test" desc="بصورت ای جکسی جستجو کن" itemId="_id"></ali-ajax-select>-->

<!--            <div class="mt-2">-->
<!--              <label>تاریخ و ساعت</label>-->
<!--              <date-picker />-->
<!--            </div>-->
            <my-input v-model="myValue" @input="(newValue) => {myValue = newValue}"></my-input>
            <div class="mt-2">
              <label>عنوان</label>
              <input class="form-control" type="text" name="title">
            </div>
            <div class="mt-2">
              <label>توضیحات</label>
              <textarea class="form-control" name="description"></textarea>
            </div>
            <div class="mt-2">
              <label>استان</label>
              <select autocomplete="off" class="form-control" @change="getCities($event)" name="state_id">
                <option value="0" disabled selected>لطفا استان مورد نظر را انتخاب نمایید</option>
                <option :key="state._id" v-for="state in states" :value="state._id">{{ state.title }}</option>
              </select>
            </div>
            <div class="mt-2">
              <label>شهر</label>
              <div class="city_div">
                <select name="city_id" data-title="استان را انتخاب کنید" class="form-control">
                  <option :key="city._id" v-for="city in cities" :value="city._id">{{ city.title }}</option>
                </select>
              </div>
            </div>
            <div class="mt-2">
              <label>تلفن ثابت</label>
              <input class="form-control" type="text" name="telephone">
            </div>
            <div class="mt-2">
              <label>تاریخ تستی</label>
            </div>
            <div class="mt-2">
              <label>آدرس</label>
              <textarea class="form-control" name="address"></textarea>
            </div>
            <div class="">
              <button class="btn btn-success btn-block btn-lg" type="submit">افزودن انبار</button>
            </div>
          </AjaxForm>
        </ion-card-content>
      </ion-card>

    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
import {IonPage} from '@ionic/vue';
import MyInput from "@/components/myInput";
import AjaxForm from "@/components/AjaxForm";
// import AliSelect from "@/components/aliSelect/index";
// import AliAjaxSelect from "@/components/aliAjaxSelect/index";

// import {getFormData} from '@/shared/helper'

export default {
  name: "AddWarehouse",
  components: {
    AjaxForm,
    MyInput,
    // AliSelect,
    // AliAjaxSelect,A
    IonPage
  },
  data()
  {
    return {
      myValue:{x:1,y:2},
      states: [],
      dateTime:'',
      cities: [{_id: 0, title: 'ابتدا استان را انتخاب نمایید'}],
      selectedStates:[
        {
          _id:'5cd41db1a1662b43b0fc5034',
          title:'خراسان جنوبی'
        },
        {
          _id:'5cd41db1a1662b43b0fc503c',
          title:'خراسان رضوی'
        },
      ],
      // testVar:'salam'
    }
  },
  watch:{
    myValue:function ()
    {
      console.log(this.myValue);
    }
  },

  setup()
  {
    const customAlertOptions = {
      header: 'Pizza Toppings',
      subHeader: 'Select your toppings',
      message: '$1.00 per topping',
      translucent: true
    };
    return {
      customAlertOptions
    }
  },
  async mounted()
  {
    this.states = await this.getStates();
  },
  methods: {
    ajaxFormCallback:function ()
    {
      alert('im alive')
    },
    ...mapActions("app", {
      getStates: 'getStates',
      apiGetCities: 'getCities',
      ajaxChange:function (chert,items)
      {
        console.log('ajaxChange')
        console.log(items);
        console.log(JSON.stringify(items));
        // console.log("test ="+this.testVar);
      },
      simpleChange:function (chert,items)
      {
        console.log('simpleChange')
        console.log(items);
        // console.log(this.testVar);
      },
    }),
    async getCities(event)
    {
      const result = await this.apiGetCities(event.target.value);
      if (result)
      {
        this.cities = result.cities;
      }
    }
  }
}
</script>

<style scoped>

</style>